import { render, staticRenderFns } from "./CtGroup.vue?vue&type=template&id=3190fcb4&"
import script from "./CtGroup.vue?vue&type=script&lang=js&"
export * from "./CtGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports